<button
class="pay"
style="width: 100%;"
[disabled]="!termsCondictios || loading"
id="btnSend" (click)="makePayment(totalToPay)">
<span class="lds-dual-ring" *ngIf="loading"></span>&nbsp;&nbsp;&nbsp;<span *ngIf="loading">Please Wait</span>
          <span *ngIf="!loading">Accept</span>
</button>
